import React, { useEffect, useRef, useState } from "react";
import { getWorkWiseAuthToken } from './helper'
import { workwiseServices } from "../Workw-Api/api";
import { useHistory, useParams } from "react-router-dom";
import { useDocument } from "../Pages/SpreadsheetContainer/documentInfoContex";
import SplashScreen from "../components/SplashScreen/SplashScreen";
import { getMergedCachedData } from "./documentCache";
import { isEffectivelyOffline } from "./helper";
import { isLocalGridRoute } from "./localGrids";

const EXIT_DURATION = 550;
// Auth often resolves in a few hundred ms (and instantly when it is skipped),
// which made the loader flash on and straight back off. Hold it on screen for
// at least this long so the intro animation reads as intentional.
const MIN_VISIBLE_DURATION = 1500;

export const AuthenticateDocument = ({ setIsLoading, background = false }) => {


  const history = useHistory();
  const { id } = useParams();
  const [exiting, setExiting] = useState(false);
  const exitTimeoutRef = useRef(null);
  const holdTimeoutRef = useRef(null);
  // Wall clock of the first render, i.e. when the loader actually appeared.
  const shownAtRef = useRef(Date.now());

  useEffect(() => () => {
    clearTimeout(exitTimeoutRef.current);
    clearTimeout(holdTimeoutRef.current);
  }, []);

  // Plays the loader's fade-out before actually flipping the parent's
  // loading flag, so the document doesn't just snap into view. Background mode
  // draws no loader, so it hands over as soon as auth resolves.
  const finishLoading = () => {
    if (background) {
      setIsLoading(false);
      return;
    }

    const remainingHold = Math.max(
      0,
      MIN_VISIBLE_DURATION - (Date.now() - shownAtRef.current)
    );

    clearTimeout(holdTimeoutRef.current);
    holdTimeoutRef.current = setTimeout(() => {
      setExiting(true);
      exitTimeoutRef.current = setTimeout(() => setIsLoading(false), EXIT_DURATION);
    }, remainingHold);
  };
  const { setDocumentInfo, setIsReadOnly, setDocID, isTemplateDocument } = useDocument();

  const handleAuhenticate = async () => {
    try {
      if (id) {
        setDocID(id);
      }
      setIsLoading(true);
      const searchParams = new URLSearchParams(document.location.search)
      const isReadOnlyQuery = searchParams.get("readOnly")
      if (isReadOnlyQuery == "true") {
        setIsReadOnly(true);
      }
      // Offline + local grid: there is no server counterpart, so skip the auth
      // API entirely instead of redirecting to /no-internet.
      if (isEffectivelyOffline() && isLocalGridRoute()) {
        finishLoading();
        return;
      }
      if (!window.navigator.onLine) {
        // history.push('/no-internet');
        window.location.pathname = "/no-internet"

        return;
      }
      else {
        if (!!getWorkWiseAuthToken()) {
          const response = await workwiseServices.getDocumentById(id);
          if (response?.status == 200 && response.data?.data?.rightType !== 0 && response.data?.data) {
            finishLoading();
            setDocumentInfo(response.data.data);
            if (response.data.data.rightType == 1) {
              setIsReadOnly(true);
            }
          }
          if (response.data?.data?.rightType == 0) {
            // history.push("/unauthorized")
            window.location.pathname = "/unauthorized"
          }
          // history.push("/unauthorized")
        }
        else {
          // history.push("/unauthorized")
          window.location.pathname = "/unauthorized"

        }
      }
    } catch (error) {
      console.log({ error })
      if (error.response?.data?.responseCode === 1008) {
        if (isTemplateDocument) {
          // For templates, 1008 is not a failure, set authenticated
          finishLoading();
          return;
        } else {
          // navigate("/invalid-document")
          window.location.pathname = "/invalid-document"
        }
      }
      else {
        // history.push("/unauthorized")
        window.location.pathname = "/unauthorized"

      }
    }
    finally {
      finishLoading();
    }
  }
  // Background mode = a cached document is already painting. Seed documentInfo
  // from the cache up front so the Header renders with real data instantly,
  // instead of staying empty until the background auth API resolves below.
  useEffect(() => {
    if (!background || !id) return;
    const cached = getMergedCachedData(id);
    if (cached?.documentInfo) {
      setDocumentInfo(cached.documentInfo);
    }
  }, [background, id]);

  useEffect(() => {
    if (isTemplateDocument === null) return;
    handleAuhenticate();
  }, [isTemplateDocument]);

  // In background mode (cached doc) auth still runs via the effect above, but we
  // render nothing so no loader is shown over the instantly-rendered cached data.
  return background ? null : <SplashScreen exiting={exiting} />
}